module.exports = __webpack_public_path__ + "img/dropdownEle.f22424e8.svg";